// hooks/useExportExcel.js
import { useState, useCallback } from "react";
import * as XLSX from "xlsx";
import axios from "axios"; // or your existing api client
import { getHeader } from "../utils/util";

const useExportExcel = ({ url, buildParams, mapRow, filename = "export" }) => {
  const [exporting, setExporting] = useState(false);
  const [exportError, setExportError] = useState(null);

  const exportToExcel = useCallback(async () => {
    setExporting(true);
    setExportError(null);
    try {
      const params = buildParams();
      const { data } = await axios.get(url, { params, ...getHeader() });
      const rows = data.data.map(mapRow);

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Auto-width columns
      const colWidths = Object.keys(rows[0] || {}).map((key) => ({
        wch:
          Math.max(
            key.length,
            ...rows.map((r) => String(r[key] ?? "").length)
          ) + 2,
      }));
      worksheet["!cols"] = colWidths;

      const timestamp = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(workbook, `${filename}_${timestamp}.xlsx`);
    } catch (err) {
      setExportError(err?.response?.data?.message ?? "Export failed");
    } finally {
      setExporting(false);
    }
  }, [url, buildParams, mapRow, filename]);

  return { exportToExcel, exporting, exportError };
};

export default useExportExcel;
